export * from './LoyaltyOfferCardFloatingLabel';
